import React from "react";
import { Constants } from "../../CommonMethhods/Constants";

function ContactCard() {
  return (
    <div className="contact-card card-box row">
      {/* reach-us */}
      <div className="reach-us col-sm-5 col-md-4 col-lg-3">
        <h3 className="enquiries-title">{Constants.Reach_Us}</h3>
        <div className="reach-us-content">
          {/* <a
            href="tel:+020 3957 4151"
            className="sm-desc contact-content contact-details-wrapper"
          >
            <span className="icon-phone-icon" /> {Constants.contact_No}
          </a> */}
          <a
            href="mailto:customercare@BFSL.com"
            className="sm-desc contact-content"
          >
            <span className="icon-email" />
            {Constants.Email_Id}
          </a>
        </div>
      </div>
      {/* office */}
      <div className="office col-sm-7 col-md-4 col-lg-4">
        <h3 className="enquiries-title">{Constants.Office}</h3>
        <div className="d-flex align-items-baseline">
          <span className="icon-location" />
          <address className="sm-desc">
            {/* {Constants.address} */}
            {/* <br /> */}
            {Constants.Full_Address}
          
          </address>
        </div>
      </div>
      {/* business hour */}
      <div className="business-hour col-sm-5 col-md-4 col-lg-3">
        <div className="wrapper-calender">
          <h3 className="enquiries-title">{Constants.Business_Hours}</h3>
          {/* <button className="calender-button"> */}
          <a
            target="_blank"
            href="https://www.nseindia.com/resources/exchange-communication-holidays"
            rel="noreferrer"
            className="calender-btn"
          >
            Calender
            <span className="icon-icon-external-link"></span>
          </a>
          {/* </button> */}
        </div>
        <div className="business-hour-content">
          <div className="contact-content working-day-wrapper">
            <span className="icon-watch" />
            <span className="sm-desc">{Constants.Working_Hrs}</span>
          </div>
          <div>
            <span className="saturday-dot" />
            <span className="sm-desc">{Constants.Working_Saturday}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactCard;
